document.addEventListener("DOMContentLoaded", function() {
    const form = document.getElementById("newsletter-form-customed");
    const messageBox = document.getElementById("newsletter-message-customed");

    form.addEventListener("submit", function(e) {
      e.preventDefault();

      const formData = new FormData(form);
      const email = formData.get("contact[email]");

      if (!email || !/^\S+@\S+\.\S+$/.test(email)) {
        messageBox.textContent = "Please enter a valid email address.";
        messageBox.style.color = "red";
        return;
      }

      fetch("/contact", {
        method: "POST",
        headers: {
          'Accept': 'application/json'
        },
        body: formData
      })
      .then(response => {
        if (response.ok) {
          messageBox.textContent = "Thanks for signing up!";
          messageBox.style.color = "green";
          form.reset();
        } else {
          return response.text();
        }
      })
      .then(data => {
        if (!data) return;
        const parser = new DOMParser();
        const doc = parser.parseFromString(data, "text/html");
        const errorMessage = doc.querySelector(".form-message--error");

        if (errorMessage) {
          messageBox.innerHTML = errorMessage.textContent;
          messageBox.style.color = "red";
        }
      })
      .catch(() => {
        messageBox.textContent = "Something went wrong. Please try again later.";
        messageBox.style.color = "red";
      });
    });
  });